import React, {useEffect, useRef, useState} from 'react';

import CardHeader from '../../components/common/card-header/CardHeader';
import {Button, Card, Divider, FlexItem, FlexLayout, H3, Link, StackLayout, Text} from '@salt-ds/core';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {StaticListItemContent} from '@salt-ds/lab';
import {useLocation, useNavigate} from 'react-router';

function OnlineProfileRegistrationCompleted() {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const {formData} = location.state || {formData: {userId: "", orgId:""}};
  const mainRef = useRef(null);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.completed.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== Constants.onlineProfileRegistrationAuthenticate) {
      navigate('/');
    }
  }, [intl,navigate,location]);

  const handleBackToLogin = () => {
    navigate("/", {state: formData});
  }
  const [hasError, setHasError] = useState(true);
  const [errorMessage, setErrorMessage] = useState(Constants.onlineProfileRegistrationCompletedStepSuccessMessage(sessionStorage.getItem("userEmail")));

  return (
      <main ref={mainRef} role="main" aria-label="Online Profile Registration Completed" tabIndex="-1">
    <FlexLayout className={"page-content"}>
      <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
        <div>
          <CardAlert status={"success"} setHasError={true}>{errorMessage}</CardAlert>
        </div>
      </FlexItem>
      <FlexItem>
        <Card className="card-wrapper">
          <FlexItem className="card-content">
            <StackLayout gap={2.5}>
              <CardHeader heading={Constants.onlineProfileRegistrationTitle}
                subheading={Constants.onlineProfileRegistrationCompletedTitle}
                style={{maxWidth: "24.5rem"}} />
              <FlexItem>
                <Text>
                  {Constants.onlineProfileRegistrationCompletedInstructionalText}
                </Text>
              </FlexItem>
              <StackLayout gap={0.5}>
                <H3>Organization and User ID</H3>
                <FlexLayout>
                  <StaticListItemContent>
                    <StackLayout gap={0.5}>
                      <Text><b>{Constants.orgIdLabel}</b></Text>
                      <Text>
                        {/*{sessionStorage.getItem("orgName")}*/}
                        {formData.orgId}
                      </Text>
                    </StackLayout>
                  </StaticListItemContent>
                  <StaticListItemContent>
                    <StackLayout gap={0.5}>
                      <Text><b>{Constants.userIdLabel}</b></Text>
                      <Text>
                        {sessionStorage.getItem("loginName")}
                      </Text>
                    </StackLayout>
                  </StaticListItemContent>
                </FlexLayout>
              </StackLayout>
              <Divider />
              <StackLayout gap={2.5}>
                <FlexItem>
                  <H3>Temporary Password</H3></FlexItem>
                <FlexItem>
                  <Text>
                    {Constants.onlineProfileRegistrationCompletedInstructionalTempPasswordText}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <Link tabIndex={0} color="info" className={"links"} onClick={() => navigate(Constants.forgotPassword, {state: { formData,from: Constants.profileRegistrationCompleted}})}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        navigate(Constants.forgotPassword, {state: { formData,from: Constants.profileRegistrationCompleted}});
                      }
                    }}>
                    {Constants.forgotPasswordTitle}
                  </Link>
                </FlexItem>
              </StackLayout>
              <FlexItem style={{alignSelf: 'end', marginTop: '30%'}}>
                <Button sentiment="accented" appearance="solid" type="submit" onClick={handleBackToLogin}>
                  CONTINUE
                </Button>
              </FlexItem>
            </StackLayout>
          </FlexItem>
        </Card>
      </FlexItem>
    </FlexLayout>
      </main>
  );
}

export default OnlineProfileRegistrationCompleted;